import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=175d4214"
import script from "./edit-password.vue?vue&type=script&lang=js"
export * from "./edit-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports